import parameter from './parameter'

export default {
  path: 'operation',
  meta: {
    label: 'operation',
    auth: 'operation'
  },
  component: {
    name: 'Operation',
    render(c) {
      return c('router-view')
    }
  },
  children: [parameter]
}
